import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import { actionTypes } from './action-types'
import { fetchConfiguredUplift } from './api'

/**
 * Failures are deliberately silent: the amount is supplementary to the preferences screen, so a
 * failed lookup leaves the card absent rather than raising a notification over the page.
 */
export function* saga() {
  yield takeLatestApiCall(actionTypes.ENTITY_FETCH_BEGIN, fetchConfiguredUplift)
}
